import client from '@/api/client.js';
import store from "@/store";
//import i18n from '@/plugins/i18n.js'
export default {
    methods: {
        async getArticleAsInvoiceDetail(articleNumber, jobId) {
            if (!articleNumber) return null;
            var meta = {
                clientApiMethod: 'getArticleAsInvoiceDetail',
                input: { articleNumber, jobId },
                noClutter: true,
                icon: "mdi-information-outline",
                color: "warning",
                onErrorMessage: (event) => event.response.data.Message
            }
            var response = await client()
                .get(store.state.apiRouteRoot + `invoice/article/detail?articleNumber=${encodeURI(articleNumber)}&childJobId=${jobId}`, { meta: meta });
            return response.data;
        },
        async moveInvoiceDetail(dto) {
            var meta = {
                clientApiMethod: 'moveInvoiceDetail',
                input: { dto },
                successText: this.$t("servicesystem.responses.moved_orderline", { okey: this.$t("servicesystem.common_objects.order.orderline") })
            }
            var response = await client().post(store.state.apiRouteRoot + "invoice/detail/move", dto, { meta: meta })
            return response?.data;
        },
        async linkInvoiceDetail(dto) {
            var meta = {
                clientApiMethod: 'linkInvoiceDetail',
                input: { dto },
                //successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.order.orderline") })
            }
            var response = await client().post(store.state.apiRouteRoot + "invoice/detail/link", dto, { meta: meta })
            return response?.data;
        },
        async changeInvoiceDetail(payload) {
            var meta = {
                clientApiMethod: 'changeInvoiceDetail',
                input: { payload },
                //successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.order.orderline") })
            }
            var response = await client().post(store.state.apiRouteRoot + "invoice/detail/update", payload, { meta: meta })
            return response?.data;
        },
        async deleteInvoiceDetail(detail) {
            var meta = {
                clientApiMethod: 'deleteInvoiceDetail',
                input: { detail: detail },
                //successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.order.orderline") })
            }
            var response = await client().post(store.state.apiRouteRoot + "invoice/delete", detail, { meta: meta })
            return response?.data;
        },
    }
}